import axios from "axios";

function handleUrl() {
  if (window.location.href.includes("localhost") || window.location.href.includes(":3000"))
    return "https://apistage.direcional.com.br/corretorapi/v1";

  if (window.location.href.includes("dev"))
    return "https://apidev.direcional.com.br/corretorapi/v1";

  if (window.location.href.includes("qa"))
    return "https://apihmg.direcional.com.br/corretorapi/v1";

  if (window.location.href.includes("stage"))
    return "https://apistage.direcional.com.br/corretorapi/v1";

  return "https://api.direcional.com.br/corretorapi/v1";
}

const api = axios.create({
  baseURL: handleUrl(),
  headers: {
    client_id: "b53793b2-7c67-42f4-ac30-06f3a6295179",
  },
});

// Interceptor para adicionar token nas requisições
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("@token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratar respostas e refresh token
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      !originalRequest.url?.includes("/login") &&
      !originalRequest.url?.includes("/refresh-token")
    ) {
      // 🔔 Dispara evento global de sessão expirada
      window.dispatchEvent(new CustomEvent("sessionExpired"));

      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default api;
